import React from 'react';
import { Grid, Column } from 'luna-react';

export default function Disclaimer({ lastUpdateDateString }) {
  return (
    <Grid gutter="collapse" className="cryptoDisclaimer">
      <Column width="1/1" s="1/2" sLast>
        <em>Last updated on {lastUpdateDateString}</em>
      </Column>
      <Column width="1/1" s="1/2">
        <em>All data sourced from CoinGecko</em>
      </Column>
    </Grid>
  );
}



// WEBPACK FOOTER //
// ./src/Disclaimer/index.js